import { useEffect } from "react";

interface Props {
  isOpen: boolean;
  orderRef: string;
  onClose: () => void;
  totalItems: number;
}

export default function OrderConfirmation({ isOpen, orderRef, onClose, totalItems }: Props) {
  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
      <div className="relative bg-white rounded-lg w-full max-w-md p-8 text-center">
        {/* Success icon */}
        <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-5">
          <i className="ri-check-double-line text-4xl text-teal-600"></i>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
          Order Placed Successfully!
        </h2>
        <p className="text-gray-500 text-sm mb-5">
          Thank you for your order. Our team will review it and contact you within 1 business day to confirm details and arrange delivery.
        </p>

        <div className="bg-teal-50 rounded-lg p-4 mb-6">
          <p className="text-xs text-teal-600 font-semibold uppercase tracking-wider mb-1">Your Order Reference</p>
          <p className="text-2xl font-bold text-teal-700 tracking-widest">{orderRef}</p>
          <p className="text-xs text-gray-500 mt-1">{totalItems} item{totalItems !== 1 ? "s" : ""} ordered</p>
        </div>

        <div className="space-y-2 text-sm text-gray-600 mb-6">
          <div className="flex items-center gap-2 justify-center">
            <i className="ri-mail-line text-teal-600"></i>
            A confirmation has been sent to your email
          </div>
          <div className="flex items-center gap-2 justify-center">
            <i className="ri-phone-line text-teal-600"></i>
            We&apos;ll call you within 24 hours to confirm
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={onClose}
            className="w-full bg-teal-600 hover:bg-teal-500 text-white font-bold py-3 rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            Continue Shopping
          </button>
          <a
            href="tel:0724114555"
            className="w-full border border-gray-200 text-gray-700 hover:bg-gray-50 font-semibold py-3 rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line text-teal-600"></i>
            Call Us: 072 411 4555
          </a>
        </div>
      </div>
    </div>
  );
}
